// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#PW_Reset_Container {
    position: absolute;
    aspect-ratio: 16/9;
    /* height: 100%; */
    max-width: 177.778vh;
    max-height: 56.25vw;
    width: 100%;

    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;

    z-index: 101;

    container-type: size;
}

#PW_Reset_Container img {
    position: absolute;
    left: 28.885%;
    top: 25.5%;

    width: 46.77%;

    z-index: inherit;
}

#PW_Reset_Container button {
    position: absolute;
    top: 53%;

    width: 12.11%;
    height: 3.4259%;

    border-radius: 0%;

    background-color: #747474;
    border: none;

    color: white;
    font: 2cqmin MyriadPro-Regular;
    line-height: 1cqmin;

    z-index: inherit;
}

#PW_Reset_Container button:hover {
    color: goldenrod;
    background-color: #6b6b6b;
    border: 1px solid goldenrod;
}

#PW_Reset_Container button:focus {
    color: goldenrod;
    background-color: #6b6b6b;
    border: 1px solid goldenrod;
}

#PWR_ResetBtn {
    left: 46.875%;
}

#PWR_CancelBtn {
    left: 60.1%;
}

#PWR_HeaderSpan {
    position: absolute;

    left: 53%;
    top: 30%;

    transform: translate(-50%);

    width: 40%;

    z-index: inherit;
    color: white;
    font: 2.4cqmin MyriadPro-Regular;
    line-height: 3cqmin;
}

#PWR_TextInputLabel {
    position: absolute;

    left: 35%;
    top: 46.8%;

    z-index: inherit;
    color: white;

    font: 2.4cqmin MyriadPro-Regular;
    line-height: 3cqmin;
}

#PWR_EmailInput:focus {
    border-color:goldenrod;
}

#PWR_EmailInput::selection {
    background-color: white;
}

#PWR_EmailInput {
    position: absolute;

    left: 46.875%;
    top: 46%;

    width: 25.3385%;
    height: 4.63%;

    background-color: transparent;

    border: 2px solid whitesmoke;

    z-index: inherit;
    color: white;
    font: 2.4cqmin MyriadPro-Regular;
    line-height: 3cqmin;
    padding-left: 10px;
    padding-left: 1cqmin;
}

#PWR_EmailInput:focus {
    outline: none;
}

#PWReset_ErrorPopup {
    position:absolute;

    left: 46.875%;
    top: 41%;

    z-index: 102;

    width: 9%;
    height: 4.63%;

    border: 3px;
    border-radius: 4px;

    background-color: white;

    container-type: size;
}

#PWReset_ErrorPopup p {
    margin-top: 8%;
    margin-left: 4%;

    z-Index: "inherit";
    
    pointer-events: none;
    
    color: "#747474";
    font: 40cqh MyriadPro-Regular;
}

.ErrorContainer {
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/PasswordReset.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;;IAEX,gCAAgC;IAChC,QAAQ;IACR,SAAS;;IAET,YAAY;;IAEZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;;IAEV,aAAa;;IAEb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;;IAER,aAAa;IACb,eAAe;;IAEf,iBAAiB;;IAEjB,yBAAyB;IACzB,YAAY;;IAEZ,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;;IAEnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,QAAQ;;IAER,0BAA0B;;IAE1B,UAAU;;IAEV,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,UAAU;;IAEV,gBAAgB;IAChB,YAAY;;IAEZ,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;;IAElB,aAAa;IACb,QAAQ;;IAER,eAAe;IACf,aAAa;;IAEb,6BAA6B;;IAE7B,4BAA4B;;IAE5B,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;;IAEjB,aAAa;IACb,QAAQ;;IAER,YAAY;;IAEZ,SAAS;IACT,aAAa;;IAEb,WAAW;IACX,kBAAkB;;IAElB,uBAAuB;;IAEvB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;;IAEf,kBAAkB;;IAElB,oBAAoB;;IAEpB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["#PW_Reset_Container {\r\n    position: absolute;\r\n    aspect-ratio: 16/9;\r\n    /* height: 100%; */\r\n    max-width: 177.778vh;\r\n    max-height: 56.25vw;\r\n    width: 100%;\r\n\r\n    transform: translate(-50%, -50%);\r\n    top: 50%;\r\n    left: 50%;\r\n\r\n    z-index: 101;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#PW_Reset_Container img {\r\n    position: absolute;\r\n    left: 28.885%;\r\n    top: 25.5%;\r\n\r\n    width: 46.77%;\r\n\r\n    z-index: inherit;\r\n}\r\n\r\n#PW_Reset_Container button {\r\n    position: absolute;\r\n    top: 53%;\r\n\r\n    width: 12.11%;\r\n    height: 3.4259%;\r\n\r\n    border-radius: 0%;\r\n\r\n    background-color: #747474;\r\n    border: none;\r\n\r\n    color: white;\r\n    font: 2cqmin MyriadPro-Regular;\r\n    line-height: 1cqmin;\r\n\r\n    z-index: inherit;\r\n}\r\n\r\n#PW_Reset_Container button:hover {\r\n    color: goldenrod;\r\n    background-color: #6b6b6b;\r\n    border: 1px solid goldenrod;\r\n}\r\n\r\n#PW_Reset_Container button:focus {\r\n    color: goldenrod;\r\n    background-color: #6b6b6b;\r\n    border: 1px solid goldenrod;\r\n}\r\n\r\n#PWR_ResetBtn {\r\n    left: 46.875%;\r\n}\r\n\r\n#PWR_CancelBtn {\r\n    left: 60.1%;\r\n}\r\n\r\n#PWR_HeaderSpan {\r\n    position: absolute;\r\n\r\n    left: 53%;\r\n    top: 30%;\r\n\r\n    transform: translate(-50%);\r\n\r\n    width: 40%;\r\n\r\n    z-index: inherit;\r\n    color: white;\r\n    font: 2.4cqmin MyriadPro-Regular;\r\n    line-height: 3cqmin;\r\n}\r\n\r\n#PWR_TextInputLabel {\r\n    position: absolute;\r\n\r\n    left: 35%;\r\n    top: 46.8%;\r\n\r\n    z-index: inherit;\r\n    color: white;\r\n\r\n    font: 2.4cqmin MyriadPro-Regular;\r\n    line-height: 3cqmin;\r\n}\r\n\r\n#PWR_EmailInput:focus {\r\n    border-color:goldenrod;\r\n}\r\n\r\n#PWR_EmailInput::selection {\r\n    background-color: white;\r\n}\r\n\r\n#PWR_EmailInput {\r\n    position: absolute;\r\n\r\n    left: 46.875%;\r\n    top: 46%;\r\n\r\n    width: 25.3385%;\r\n    height: 4.63%;\r\n\r\n    background-color: transparent;\r\n\r\n    border: 2px solid whitesmoke;\r\n\r\n    z-index: inherit;\r\n    color: white;\r\n    font: 2.4cqmin MyriadPro-Regular;\r\n    line-height: 3cqmin;\r\n    padding-left: 10px;\r\n    padding-left: 1cqmin;\r\n}\r\n\r\n#PWR_EmailInput:focus {\r\n    outline: none;\r\n}\r\n\r\n#PWReset_ErrorPopup {\r\n    position:absolute;\r\n\r\n    left: 46.875%;\r\n    top: 41%;\r\n\r\n    z-index: 102;\r\n\r\n    width: 9%;\r\n    height: 4.63%;\r\n\r\n    border: 3px;\r\n    border-radius: 4px;\r\n\r\n    background-color: white;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#PWReset_ErrorPopup p {\r\n    margin-top: 8%;\r\n    margin-left: 4%;\r\n\r\n    z-Index: \"inherit\";\r\n    \r\n    pointer-events: none;\r\n    \r\n    color: \"#747474\";\r\n    font: 40cqh MyriadPro-Regular;\r\n}\r\n\r\n.ErrorContainer {\r\n    pointer-events: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
